import { merge, set, get } from 'lodash';
import { bigQuery } from '@fiverr-private/obs';
import { MODES, MODE } from '../constants';

export const WIDGET_TYPES = {
    [MODES.RANDOM_GIGS]: 'random_gig_ads',
    [MODES.SPECIFIC_GIG]: 'specific_gig_ads',
} as const;

export type WIDGET_TYPE = (typeof WIDGET_TYPES)[keyof typeof WIDGET_TYPES];

/**
 * Map widget type value
 * @param {object} widgetType widget type
 * @returns {object} Mapped widget type
 */
export const mapWidgetType = (widgetType: MODE = MODES.RANDOM_GIGS): WIDGET_TYPE => WIDGET_TYPES[widgetType];

/**
 * Send BQ event
 * @param {object} data BQ data to send
 */
export const sendBQ = (data) => {
    const general = {
        group: 'nga',
    };
    const metadata = get(data, 'page.element.metadata', {});

    merge(general, data);
    set(general, 'page.element.metadata', JSON.stringify(metadata));

    bigQuery.send(general);
};
